<template>
  <div>
    <div class="mb-4">
      <label class="label cursor-pointer">{{ t('aiChatAgentSetup.avatars.providerLabel', 'Avatar Provider') }}</label>
      <select v-model="localSelectedProvider" class="select select-bordered w-full">
        <option
          v-for="option in providerOptions"
          :key="option.id"
          :value="option.id"
        >
          {{ option.label }}
        </option>
      </select>
    </div>
    <component
      v-if="activeComponent !== null"
      :is="activeComponent"
      :model-value="activeConfig"
      @update:model-value="updateProviderConfig"
    />
    <div v-else class="text-sm text-gray-500">
      {{ t('aiChatAgentSetup.avatars.noProvider', 'Select a provider to continue.') }}
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useI18n } from '@/i18n';
import DidAvatarProvider from './avatars/DidAvatarProvider.vue';

const props = defineProps({
  selectedProvider: {
    type: String,
    required: true
  },
  modelValue: {
    type: Object,
    required: true
  }
});
const emit = defineEmits(['update:selectedProvider', 'update:modelValue']);
const { t } = useI18n();
const providerComponentMap = {
  did: DidAvatarProvider
};
const providerOptions = computed(() => [
  {
    id: 'did',
    label: t('aiChatAgentSetup.avatars.providers.did', 'DiD Avatars')
  }
]);
const localSelectedProvider = computed({
  get: () => {
    if (typeof props.selectedProvider === 'string' && providerComponentMap[props.selectedProvider] !== undefined) {
      return props.selectedProvider;
    }
    return 'did';
  },
  set: value => emit('update:selectedProvider', value)
});
const activeComponent = computed(() => {
  const component = providerComponentMap[localSelectedProvider.value];
  if (component === undefined) {
    return null;
  }
  return component;
});
const activeConfig = computed(() => {
  const providerId = localSelectedProvider.value;
  const storedConfig = props.modelValue[providerId];
  if (storedConfig === undefined || storedConfig === null) {
    return {};
  }
  return storedConfig;
});
function updateProviderConfig(value) {
  const providerId = localSelectedProvider.value;
  const nextValue = {
    ...props.modelValue,
    [providerId]: value
  };
  emit('update:modelValue', nextValue);
}
</script>



